export function createLink(contact, client) {
  switch (contact.type.type) {
    case 0:
      return `tel:${contact.value}`;
    case 1:
      return `sms:/${contact.value}`;
    case 3:
      return `mailto:${contact.value}`;
    case 5:
      return contact.value;
    case 6:
      return `https://t.me/${contact.value}`;
    case 7:
      return client === "android"
        ? `whatsapp://send?phone=98${contact.value.substring(
            1
          )}&amp;abid=98${contact.value.substring(1)}`
        : `https://api.whatsapp.com/send?phone=98${contact.value.substring(1)}`;
    case 8:
      return `https://instagram.com/${contact.value}`;
    default:
      return "";
  }
}

export default createLink;
